export default "__VITE_ASSET__OHmqKo7c__"